import React from 'react'
import { Tooltip, Chip } from '@mui/material'
import { MdOutlineRemoveRedEye } from 'react-icons/md'
import { BsFiletypeJson } from 'react-icons/bs'

// Dummy data representing app users
const userData = [
  {
    id: 1,
    name: 'John Doe',
    email: 'john.doe@example.com',
    role: 'Admin',
    status: 'Active'
  },
  {
    id: 2,
    name: 'Jane Smith',
    email: 'jane.smith@example.com',
    role: 'User',
    status: 'Inactive'
  },
  {
    id: 3,
    name: 'Alice Johnson',
    email: 'alice.johnson@example.com',
    role: 'Moderator',
    status: 'Active'
  }
]

const UserManagement = () => {
  const tableHeaders = [
    { name: 'ID' },
    { name: 'Name' },
    { name: 'Email' },
    { name: 'Role' },
    { name: 'Status' },
    { name: 'Actions' }
  ]

  const getColor = status => {
    switch (status) {
      case 'Active':
        return 'success'
      case 'Inactive':
        return 'default'
      default:
        return 'warning'
    }
  }

  const onViewUser = user => {
    alert(`Viewing details for: ${user.name}`)
  }

  const onJsonView = user => {
    alert(`JSON Data:\n${JSON.stringify(user, null, 2)}`)
  }

  return (
    <div class='eligibility_container'>
      <div class='eligibility-page'>
        <div className='flex justify-between flex-col lg:flex-row gap-4 mb-3 px-3'>
          <div className=''>
            <Tooltip
              placement='right'
              title='Keep track of your Eligibility Transactions'
              className='my-auto !mt-2'
            >
              <span className='font-semibold text-black/70 text-lg '>
                Users
                <span className='italic text-lg ml-1'>
                  ({0} <span className='text-xs font-bold italic'>Entries</span>
                  )
                </span>
              </span>
            </Tooltip>
          </div>
        </div>
        <div className='super-git-table !p-0 !m-0'>
          <table className='table-super-git !p-0'>
            <thead className='!p-0'>
              <tr className='!p-0'>
                {tableHeaders.map((el, index) => (
                  <th className='!p-2 !text-sm' key={`tableHeaders_${index}`}>
                    {el.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {userData.map((user, index) => (
                <tr className='!p-0' key={`userData_${index}`}>
                  {/* ID */}
                  <td className='!p-1 !text-sm text-left'>{user.id}</td>

                  {/* Name */}
                  <td className='!p-1 !text-sm text-left'>
                    {user.name.length > 20 ? (
                      <Tooltip title={user.name}>
                        <span>{user.name.slice(0, 20)}...</span>
                      </Tooltip>
                    ) : (
                      user.name
                    )}
                  </td>

                  {/* Email */}
                  <td className='!p-1 !text-sm text-left'>
                    {user.email.length > 30 ? (
                      <Tooltip title={user.email}>
                        <span>{user.email.slice(0, 30)}...</span>
                      </Tooltip>
                    ) : (
                      user.email
                    )}
                  </td>
                  <td className='!p-1 !text-sm capitalize text-left'>
                    {user.role}
                  </td>
                  <td className='!p-1 !text-sm text-left'>
                    <Chip
                      label={user.status}
                      color={getColor(user.status)}
                      size='small'
                      className='uppercase !text-xs'
                    />
                  </td>
                  <td className='user-action flex gap-2 justify-center items-center h-full mx-2  !p-1'>
                    <Tooltip title='View'>
                      <div
                        onClick={() => onViewUser(user)}
                        className='text-xl cursor-pointer'
                      >
                        <MdOutlineRemoveRedEye />
                      </div>
                    </Tooltip>
                    <Tooltip title='JSON View'>
                      <div
                        onClick={() => onJsonView(user)}
                        className='text-xl cursor-pointer'
                      >
                        <BsFiletypeJson />
                      </div>
                    </Tooltip>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default UserManagement
